import React from "react"
import ExpungeGrid from "../../components/expungeGrid"
import {Box, Button } from "@mui/material"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import { Link } from "react-scroll"


function Expungement() {

  const titleStyle: React.CSSProperties = {
  width: '550px',
  //height: '156px',
  marginLeft: '445px',
  //marginTop: '118px',
  fontFamily: 'DM Sans',
  fontSize: '60px',
  //lineHeight: '78px',
  color: '#000000',
  textAlign: 'center',
}

const bodyStyle: React.CSSProperties = {
  width: '756px',
  height: '78px',
  marginLeft: '342px',
  fontFamily: 'DM Sans',
  fontSize: '30px',
  lineHeight: '40px',
  color: '#000000',
  textAlign: 'center',
}



const buttonStyle: React.CSSProperties = {
  width: '247px',
  height: '45px',
  fontFamily: 'DM Sans',
  fontSize: '24px',
  // marginLeft: '342px', IDK if this is necessary or not. Wasn't needed on mine but idk.
  color: '#A7BA87',
  textAlign: 'center',
  textTransform: 'unset',
  //display: 'flex',
  alignItems:'center',
  flexWrap: 'wrap',
}

const space: React.CSSProperties = {
  marginTop: '500px',
}

  const titles = ["Expungement","test", "test2"]
  const descs = ["Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.", 
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
  "Lore"]
  //The link react scroll button isn't working but I'm not sure how to fix it. 
  return (
    <div className="App">
      <Box>
      <h1 style={titleStyle}>Welcome to Friends of the Miracle Mile</h1>
      <br></br>
      <p style={bodyStyle}>We're on a mission to help expunge non-violent criminal records and provide education for job readiness.</p>
      <br></br><br></br>
      <Button style={buttonStyle}>
        Learn More
        <KeyboardArrowDownIcon style={{fontSize: 130}} />
        <Link 
          activeClass="active"
          to="Expungement"
          spy={true} 
          smooth={true}
          offset={-70}
          duration={500}
        ></Link>
      </Button>
    </Box>
    <div style = {space}> </div>
    <div>
      <div id ="Expungement"> 
        <h1 style = {titleStyle}>Expungement:</h1>
      </div>
      <h1>The Three Stages.</h1>
      <br></br><br></br>
      {titles.map((title, index) => {
        return (
          <ExpungeGrid
            imageSrc="https://place-hold.it/50x50"
            title={title}
            description={descs[index]}
          />
        )
      }
      )}
      <Button variant = "contained"
      sx = {{
        bgcolor: 'lightGreen',
        color: 'black',
        borderShadow: 24,
        borderRadius: 8,
        textTransform: 'none'
      }}
      onClick={() => { console.log('onClick');}}
      > Check Eligibility </Button>
      <br></br><br></br>
      </div>
    </div>
  )
}

export default Expungement